var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchonherz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 5000 1558",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Sch\\xF6nherz",
    transform: "matrix(4.16667,0,0,4.16667,0,0)",
    className: "dynamicColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,144.87,219.696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-219.696L-70.236,-216.41L-73.212,-0.434L-32,0L-24.67,-14.775L1.486,-28.816L0,-219.696Z",
    style: {
      fill: "rgb(22,60,101)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,97.3179,113.869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,137.174L9.54,117.946L-35.032,117.529L-31.697,-97.592L-32.784,-97.552L-53.697,-96.778L-58.442,123.41L-92.708,160.21L-95.518,234.766L-5.769,234.625L0,137.174Z",
    style: {
      fill: "rgb(22,60,101)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,176.978,24.3592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,150.081L-2.332,-11.511L-21.588,-11.403L-22.957,-11.353L-21.442,161.592L0,150.081Z",
    style: {
      fill: "rgb(22,60,101)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,152.732,277.508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-22.13L10.943,-35.261L21.885,-21.035L21.156,15.806L-1.094,15.076L0,-22.13ZM45.595,-17.023L56.537,-28.695L65.656,-16.658L64.927,18.358L44.865,17.629L45.595,-17.023ZM91.189,-11.187L100.308,-21.765L108.698,-11.552L109.063,21.641L90.095,21.276L91.189,-11.187ZM177.272,-12.281L184.203,-0.974L183.473,26.748L169.248,26.748L168.518,-2.433L177.272,-12.281ZM208.641,-9.728L215.937,0.485L216.666,27.477L201.346,27.843L200.981,0.85L208.641,-9.728ZM235.269,-6.08L242.199,3.768L242.199,28.936L229.432,29.666L229.067,3.403L235.269,-6.08ZM-42.434,-23.224L-48.27,70.154L121.125,70.704L122.193,19.21L129.854,19.654L129.854,-6.81L139.702,-17.752L148.821,-7.174L148.485,20.734L155.751,21.155L156.829,70.82L251.318,71.127L248.765,-23.224L183.352,-61.524L36.354,-93.257L-21.034,-64.076L-42.434,-23.224Z",
    style: {
      fill: "rgb(22,60,101)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,361.049)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 404.051,
    height: 13.09,
    style: {
      fill: "rgb(22,60,101)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,479.369,263.503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,95.04L7.002,78.045C14.49,83.297 21.855,85.923 29.103,85.923C40.236,85.923 45.806,82.033 45.806,74.253C45.806,70.606 44.492,67.13 41.866,63.822C39.241,60.516 33.831,56.809 25.637,52.699C17.443,48.591 11.925,45.212 9.081,42.561C6.235,39.911 4.047,36.763 2.516,33.115C0.984,29.469 0.219,25.433 0.219,21.008C0.219,12.741 3.246,5.886 9.299,0.438C15.353,-5.007 23.122,-7.731 32.604,-7.731C44.953,-7.731 54.022,-5.421 59.81,-0.801L54.047,15.537C47.385,10.772 40.359,8.39 32.969,8.39C28.591,8.39 25.2,9.545 22.793,11.853C20.386,14.164 19.183,17.167 19.183,20.861C19.183,26.988 25.966,33.359 39.532,39.972C46.68,43.473 51.834,46.694 54.995,49.637C58.155,52.579 60.563,56.007 62.216,59.92C63.869,63.835 64.696,68.199 64.696,73.013C64.696,81.668 61.279,88.792 54.449,94.384C47.617,99.977 38.462,102.771 26.987,102.771C17.019,102.771 8.023,100.194 0,95.04",
    style: {
      fill: "rgb(22,60,101)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,621.015,358.252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-65.719L-7.804,-52.079C-12.084,-56.115 -17.822,-58.133 -25.018,-58.133C-31.923,-58.133 -37.381,-55.835 -41.393,-51.24C-45.404,-46.645 -47.41,-40.287 -47.41,-32.166C-47.41,-15.78 -39.606,-7.586 -23.998,-7.586C-17.239,-7.586 -11.281,-9.823 -6.128,-14.297L0.583,0.072C-4.717,3.38 -9.35,5.469 -13.312,6.345C-17.274,7.22 -21.955,7.658 -27.352,7.658C-39.412,7.658 -48.93,4.145 -55.907,-2.882C-62.885,-9.908 -66.375,-19.669 -66.375,-32.166C-66.375,-44.468 -62.557,-54.413 -54.923,-61.998C-47.289,-69.584 -36.883,-73.377 -23.705,-73.377C-14.612,-73.377 -6.711,-70.824 0,-65.719",
    style: {
      fill: "rgb(22,60,101)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,686.731,252.855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,111.596L0,63.456C0,58.643 -1.507,54.777 -4.521,51.86C-7.536,48.942 -11.475,47.483 -16.338,47.483C-19.354,47.483 -22.392,48.298 -25.455,49.926C-28.518,51.556 -30.705,53.416 -32.019,55.506L-32.019,111.596L-50.546,111.596L-50.546,4.376L-32.019,0L-32.019,38.439C-27.304,34.16 -20.811,32.02 -12.544,32.02C-2.771,32.02 4.816,34.731 10.214,40.153C15.608,45.575 18.309,53.343 18.309,63.456L18.309,111.596L0,111.596Z",
    style: {
      fill: "rgb(22,60,101)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,781.114,365.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-110.867C2.868,-110.867 5.312,-109.846 7.33,-107.804C9.348,-105.761 10.356,-103.305 10.356,-100.436C10.356,-97.567 9.348,-95.124 7.33,-93.106C5.312,-91.088 2.868,-90.08 0,-90.08C-2.87,-90.08 -5.324,-91.088 -7.367,-93.106C-9.408,-95.124 -10.431,-97.567 -10.431,-100.436C-10.431,-103.305 -9.408,-105.761 -7.367,-107.804C-5.324,-109.846 -2.87,-110.867 0,-110.867M-42.523,-40.7C-42.523,-23.486 -36.323,-14.88 -23.924,-14.88C-18.235,-14.88 -13.725,-17.116 -10.394,-21.59C-7.064,-26.063 -5.397,-32.432 -5.397,-40.7C-5.397,-57.67 -11.572,-66.155 -23.924,-66.155C-29.612,-66.155 -34.136,-63.918 -37.49,-59.445C-40.846,-54.971 -42.523,-48.723 -42.523,-40.7M-45.223,-110.867C-42.354,-110.867 -39.91,-109.846 -37.893,-107.804C-35.874,-105.761 -34.864,-103.305 -34.864,-100.436C-34.864,-97.567 -35.874,-95.124 -37.893,-93.106C-39.91,-91.088 -42.354,-90.08 -45.223,-90.08C-48.091,-90.08 -50.546,-91.088 -52.589,-93.106C-54.631,-95.124 -55.653,-97.567 -55.653,-100.436C-55.653,-103.305 -54.631,-105.761 -52.589,-107.804C-50.546,-109.846 -48.091,-110.867 -45.223,-110.867M-61.488,-40.7C-61.488,-52.613 -58.048,-62.313 -51.167,-69.803C-44.286,-77.29 -35.205,-81.035 -23.924,-81.035C-12.061,-81.035 -2.846,-77.436 3.72,-70.24C10.284,-63.043 13.566,-53.196 13.566,-40.7C13.566,-28.251 10.222,-18.355 3.538,-11.013C-3.149,-3.671 -12.303,0 -23.924,0C-35.789,0 -45.016,-3.707 -51.604,-11.124C-58.193,-18.538 -61.488,-28.397 -61.488,-40.7",
    style: {
      fill: "rgb(22,60,101)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,859.523,284.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,79.576L0,34.427C0,27.765 -1.276,22.902 -3.829,19.84C-6.382,16.775 -10.552,15.244 -16.338,15.244C-19.012,15.244 -21.869,15.999 -24.907,17.506C-27.947,19.013 -30.318,20.886 -32.019,23.122L-32.019,79.576L-50.254,79.576L-50.254,1.459L-37.126,1.459L-33.77,8.753C-28.811,2.918 -21.492,0 -11.814,0C-2.527,0 4.803,2.784 10.175,8.351C15.548,13.92 18.234,21.688 18.234,31.655L18.234,79.576L0,79.576Z",
    style: {
      fill: "rgb(22,60,101)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,947.998,252.855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,111.596L0,63.456C0,58.643 -1.508,54.777 -4.521,51.86C-7.538,48.942 -11.477,47.483 -16.338,47.483C-19.354,47.483 -22.392,48.298 -25.455,49.926C-28.519,51.556 -30.707,53.416 -32.02,55.506L-32.02,111.596L-50.546,111.596L-50.546,4.376L-32.02,0L-32.02,38.439C-27.303,34.16 -20.812,32.02 -12.546,32.02C-2.771,32.02 4.814,34.731 10.212,40.153C15.608,45.575 18.308,53.343 18.308,63.456L18.308,111.596L0,111.596Z",
    style: {
      fill: "rgb(22,60,101)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1000.59,333.525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-16.265L38.365,-16.265C37.101,-27.691 30.779,-33.406 19.402,-33.406C8.995,-33.406 2.528,-27.691 0,-16.265M55.142,-2.553L-0.657,-2.553C-0.317,3.672 1.823,8.51 5.762,11.963C9.701,15.416 15,17.141 21.662,17.141C29.978,17.141 36.299,14.977 40.627,10.649L47.701,24.581C41.283,29.785 31.703,32.385 18.964,32.385C7.05,32.385 -2.37,28.896 -9.3,21.919C-16.229,14.941 -19.693,5.205 -19.693,-7.293C-19.693,-19.595 -15.889,-29.564 -8.278,-37.199C-0.669,-44.832 8.461,-48.65 19.109,-48.65C30.44,-48.65 39.532,-45.269 46.39,-38.511C53.245,-31.752 56.674,-23.145 56.674,-12.691C56.674,-10.453 56.163,-7.075 55.142,-2.553",
    style: {
      fill: "rgb(22,60,101)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1117,345.997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-42.668C-3.258,-44.808 -6.832,-45.878 -10.721,-45.878C-14.952,-45.878 -18.708,-43.956 -21.991,-40.115C-25.271,-36.274 -26.913,-31.582 -26.913,-26.038L-26.913,18.454L-45.147,18.454L-45.147,-59.663L-26.913,-59.663L-26.913,-52.516C-21.808,-58.252 -15.024,-61.122 -6.564,-61.122C-0.339,-61.122 4.425,-60.174 7.732,-58.277L0,-42.668Z",
    style: {
      fill: "rgb(22,60,101)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1130.56,286.334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,78.117L0,71.917L42.379,15.9L0.73,15.9L0.73,0L69.001,0L69.001,6.419L28.154,62.217L69.438,62.217L69.438,78.117L0,78.117Z",
    style: {
      fill: "rgb(22,60,101)",
      fillRule: "nonzero"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchonherz);
export default __webpack_public_path__ + "static/media/schonherz.660ea756cca3741677778078e7768a64.svg";
export { ForwardRef as ReactComponent };